export default "__VITE_ASSET__DK9Xd38$__"